import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { isRecord } from '@rsos/base-utils';
import { setVideoSession, removeVideoSession } from '@rsos/reduxDataStore';

export const VIDEO_SESSION_EVENT_TYPE = 'video-to-911-event-v1';
export enum VideoSessionSubtype {
  Started = 'session-started',
  Ended = 'session-ended',
}

function getParsedBody(message: unknown): Record<string, unknown> | null {
  if (!isRecord(message) || message?.type !== VIDEO_SESSION_EVENT_TYPE) {
    return null;
  }

  if (isRecord(message.payload)) {
    return message.payload;
  }

  if (isRecord(message.body)) {
    return message.body;
  }

  return null;
}

const useHandleLiveVideoEvents = () => {
  const StreamWS = window?.__RSOS?.streamWS?.instance;
  const dispatch = useDispatch();

  const handleLiveVideoSessionEvent = useCallback(
    (msg: unknown) => {
      const body = getParsedBody(msg);

      if (!body) {
        return;
      }

      if (
        !(typeof body.caller_id === 'string') ||
        !(typeof body.owner_id === 'string') ||
        !(typeof body.room === 'string') ||
        !(typeof body.event === 'string')
      ) {
        return;
      }

      const isActive = body.event === VideoSessionSubtype.Started;

      if (!isActive) {
        dispatch(
          removeVideoSession({
            callID: body.caller_id,
          }),
        );
      } else {
        dispatch(
          setVideoSession({
            callID: body.caller_id,
            name: body.room,
            ownerID: body.owner_id,
          }),
        );
      }
    },
    [dispatch],
  );

  useEffect(() => {
    if (!StreamWS) {
      return;
    }

    StreamWS.addOnMessageCallback({ handleLiveVideoSessionEvent });

    return () => {
      StreamWS.removeOnMessageCallback('handleLiveVideoSessionEvent');
    };
  }, [StreamWS, handleLiveVideoSessionEvent]);
};

export default useHandleLiveVideoEvents;
